module.exports = __webpack_public_path__ + "img/thumbnail_AlpineGoat_f_normal.297f95a3.png";